export const SceneEffectType = {
	Rain: 'rain',
	Snow: 'snow',
	Firefly: 'firefly',
	Confetti: 'confetti',
	Smoke: 'smoke',
	Leafs: 'leafs',
	Glitter: 'glitter',
} as const

export type SceneEffectType = (typeof SceneEffectType)[keyof typeof SceneEffectType]
export const sceneEffectTypes = Object.values(SceneEffectType)

export const sceneEffectTypesText: Record<SceneEffectType, string> = {
	[SceneEffectType.Rain]: 'Pluie',
	[SceneEffectType.Snow]: 'Neige',
	[SceneEffectType.Firefly]: 'Lucioles',
	[SceneEffectType.Confetti]: 'Confettis',
	[SceneEffectType.Glitter]: 'Paillettes',
	[SceneEffectType.Smoke]: 'Fumée',
	[SceneEffectType.Leafs]: 'Feuillage',
}
